import { Lightning as lng } from '@lightningjs/sdk';
import { GuideProgram } from './GuideProgram';
import { _constants } from './GuideChannel';
import { Theme } from '../../../config/theme';

export class GuideChannelPage extends lng.Component {
  static _template() {
    return {
      w: w => w,
      h: h => h,
      color: Theme.Colors.Guide.background,
      rect: true,
    };
  }

  _init() {
    // this.childList.a({
    //   type: GuideProgram,
    //   datasource: undefined,
    //   backend: this._backend,
    //   w: _constants.channelProgramsWidth,
    //   x: 0,
    //   visible: true,
    // });
    this.focusIdx = -1;
  }

  _getFocused() {
    if (this.focusIdx === -1) return;
    return this._getFocusable()[this.focusIdx];
  }

  _getFocusable() {
    return this.children.filter(comp => comp.visible);
  }

  _handleRight() {
    if (this.focusIdx === -1) return;
    if (this.focusIdx < this._getFocusable().length - 1) {
      this.focusIdx += 1;
      return true;
    } else {
      return false;
    }
  }

  _handleLeft() {
    if (this.focusIdx === -1) return;
    if (this.focusIdx > 0) {
      this.focusIdx -= 1;
      return true;
    } else {
      return false;
    }
  }

  buildPage(startTime, endTime) {
    this.focusIdx = -1;
    // set all childs to invisible
    this.childList.forEach(el => (el.visible = false));
    return this.datasource.fetchPage(startTime, endTime).then(r => {
      const timeWidth = endTime.getTime() - startTime.getTime();
      let xOffset = 0;
      // console.log('GuideChannel buildpage', pageElement.id, pageElement, startTime, endTime, timeWidth, r);
      let i = 0;
      let lastEndTime = startTime.getTime();
      r.forEach(el => {
        let continuesLater = false;
        let s = el.startTime;
        let e = el.endTime;
        if (i === 0 && s < startTime.getTime()) {
          s = startTime.getTime();
        }
        if (e > endTime.getTime()) {
          e = endTime.getTime();
          continuesLater = true;
        }
        if (s > lastEndTime) {
          const noInfoWidth = ((s - lastEndTime) / timeWidth) * _constants.channelProgramsWidth;
          this._addNoInfoItem(i, xOffset, noInfoWidth);
          i += 1;
          xOffset += noInfoWidth;
        }
        const pixelWidth = ((e - s) / timeWidth) * _constants.channelProgramsWidth;
        let newProgram;
        if (i <= this.childList.length - 1) {
          // reuse element
          newProgram = this.childList.getAt(i);
          newProgram.patch({
            x: xOffset,
            w: pixelWidth,
            visible: true,
          });
          newProgram.data = { ds: el, continuesLater };
        } else {
          // add element
          newProgram = this.childList.a({
            type: GuideProgram,
            datasource: el,
            backend: this.backend,
            w: pixelWidth,
            x: xOffset,
            continuesLater,
          });
        }
        newProgram.updateFilterHighlight(this._filterState);
        xOffset += pixelWidth;
        i += 1;
        lastEndTime = e;
      });
      if (r.length === 0) {
        this._addNoInfoItem(0, 0, _constants.channelProgramsWidth);
      } else if (lastEndTime < endTime.getTime()) {
        const noInfoWidth = ((endTime.getTime() - lastEndTime) / timeWidth) * _constants.channelProgramsWidth;
        this._addNoInfoItem(i, xOffset, noInfoWidth);
      }
      this.rect = false;
      this.focusIdx = 0;
      this._refocus();
    });
  }
  set focusElement(num) {
    if (num <= 0) {
      this.focusIdx = 0;
    } else if (num > this._getFocusable().length - 1) {
      this.focusIdx = this._getFocusable().length - 1;
    } else {
      this.focusIdx = num;
    }
  }

  set focusLeftRight(left) {
    if (left) {
      this.focusIdx = 0;
    } else {
      this.focusIdx = this._getFocusable().length - 1;
    }
  }

  _addNoInfoItem(index, xOffset, width) {
    if (index <= this.childList.length - 1) {
      // reuse element
      const newProgram = this.childList.getAt(index);
      newProgram.patch({
        x: xOffset,
        w: width,
        visible: true,
      });
      newProgram.data = { ds: undefined, continuesLater: undefined };
    } else {
      this.childList.a({
        type: GuideProgram,
        datasource: undefined,
        backend: this.backend,
        w: width,
        x: xOffset,
      });
    }
  }

  /**
   * @param {IFiltersInfo} filter
   */
  updateFilterHighlights(filter) {
    this._filterState = filter;
    this.children.forEach(el => el.updateFilterHighlight(filter));
  }
}
